angular.module 'zc.commonApi'

.factory "ProjectStats", ($q, FacadeV2, AccessStats) ->

  class ProjectStats
    @getDailyProjectStats: (match, callback) ->
      dimension = 'daily'
      query =
        match: match
      query.match = _.assignIn {}, match, {
        device: null
        campaign_segment_id: null
        is_control:
          $ne: null
      }
      query.pipeline = []
      group =
        _id:
          apikey: "$apikey"
          is_control: "$is_control"
      for field in AccessStats.fields
        group[field] =
          $sum: "$#{field}"
      query.pipeline.push
        $group: group

      params = {}
      params.match = FacadeV2.encode {}, query.match
      params.pipeline = FacadeV2.encode [], query.pipeline

      FacadeV2.request "/master/access_stats/#{dimension}/aggregate", {
        params: params
      }
      .then (res) ->
        safeDiv = (a, b) ->
          if b
            a / b
          else
            0
        stats = {}
        for stat in res.data
          stat.apikey = stat._id.apikey
          stats[stat.apikey] ||= { total_conversion_price: 0 }
          for f, v of stat
            stats[stat.apikey][f] ||= 0
            stats[stat.apikey][f] += v
            stats[stat.apikey]['total_conversion_price'] += v if f == 'conversion_price'

          if stat._id.is_control
            stats[stat.apikey].ctl_conversion_rate = safeDiv stat.conversion_count, stat.session_count
            stats[stat.apikey].ctl_cart_button_click_rate = safeDiv stat.cart_button_click_count, stat.session_count
          else
            stats[stat.apikey].exp_conversion_rate = safeDiv stat.conversion_count, stat.session_count
            stats[stat.apikey].exp_cart_button_click_rate = safeDiv stat.cart_button_click_count, stat.session_count

        for apikey, stat of stats
          stat.avg_history_count = safeDiv stat.history_count, stat.session_count
          stat.avg_interest_count = safeDiv stat.interest_count, stat.session_count
        stats



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/project_stats_service.js.coffee